const PARAGRAPH_NEWS = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on FeaturedNews {
      id
      heading
      icon
      bottomSeparator
      button {
        title
        url
      }
      listing {
        nid
        title
        summaryListing
        publishedOn
        pathAlias
        memberOnly
        categories {
          name
          color
          alias
          weight
        }
        featuredImage {
          alt
          newsFeaturedImage
        }
        bodyListing
        ... on Article {
          ctaButtons {
            color
            title
            url
          }
        }
        ... on News {
          ctaButtons {
            color
            title
            url
          }
        }
      }
      type
      uuid
    }
  }
`;

export default PARAGRAPH_NEWS;
